import "core-js/modules/es6.function.name";

/* eslint-disable react/no-array-index-key */
import React from 'react';
import DocTypeWrapper from './DocTypeWrapper';
import TsDocFunctionSignature from './TsDocFunctionSignature';
import TypeExpression from './TsDocTypeExpression';
import { getFunctionNode } from './utils/tsDocTypeExpression';
export default function TsDocTypeSignature(_ref) {
  var definition = _ref.definition,
      arrowStyle = _ref.arrowStyle,
      compact = _ref.compact;

  // eventually resolves to a function call
  if (getFunctionNode(definition)) {
    return /*#__PURE__*/React.createElement(TsDocFunctionSignature, {
      compact: compact,
      definition: definition,
      arrowStyle: arrowStyle
    });
  }

  if (definition.type) {
    return /*#__PURE__*/React.createElement(DocTypeWrapper, null, /*#__PURE__*/React.createElement(TypeExpression, {
      type: definition.type,
      compact: true
    }));
  }

  if (definition.name) {
    return /*#__PURE__*/React.createElement(DocTypeWrapper, null, /*#__PURE__*/React.createElement("span", {
      className: "token builtin"
    }, definition.name));
  }

  return null;
}
export var fragment = "228399487";